;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('coreHorizontalFilters', coreHorizontalFilters)

  /* @ngInject */
  function coreHorizontalFilters () {
    return {
      restrict: 'E',
      scope: {
        filters: '<',
        show: '='
      },
      templateUrl: '/core/directives/core-horizontal-filters/core-horizontal-filters-directive.html?$$REVISION$$',
      controller: 'CoreHorizontalFiltersController'
    }
  }
})()
